import React from 'react';

const SalesManManifestComponentLoadable = React.lazy(() => import('./SalesManManifestComponent'));
const IRSSalesManManifestComponentLoadable = React.lazy(() => import('./IRSSalesManManifestComponent'));


export {
    SalesManManifestComponentLoadable,
    IRSSalesManManifestComponentLoadable
};
